<template>
  <div class="bg-light min-vh-100">
    <main class="container">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="card shadow-sm">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                <h1 class="h4 mb-0">Device Models</h1>
                <button v-if="isSupervisor" class="btn btn-primary btn-sm" @click="$router.push({ name: 'CreateDeviceModel' })">
                  New Model
                </button>
              </div>
              <p class="help mb-3">Catalog of device models with hardware specs.</p>

              <div v-if="loading" class="text-center py-5">
                <div class="spinner-border" role="status"></div>
              </div>

              <div v-else>
                <div v-if="error" class="alert alert-danger py-2">{{ error }}</div>

                <!-- Search -->
                <div class="mb-3">
                  <input v-model="search" type="text" class="form-control form-control-sm" placeholder="Search by make, model, or common name..." />
                </div>

                <div v-if="filteredModels.length === 0" class="text-muted">No device models found.</div>

                <div v-else class="table-responsive">
                  <table class="table table-sm align-middle">
                    <thead class="table-light">
                      <tr>
                        <th>Make</th>
                        <th>Model</th>
                        <th>Common Name</th>
                        <th>Type</th>
                        <th>CPU</th>
                        <th>RAM</th>
                        <th>Storage</th>
                        <th class="text-end">Devices</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="dm in filteredModels"
                        :key="dm.device_model_id"
                        :class="{ 'cursor-pointer': isSupervisor }"
                        @click="isSupervisor ? $router.push({ name: 'EditDeviceModel', params: { id: dm.device_model_id } }) : null"
                      >
                        <td>{{ dm.make }}</td>
                        <td>{{ dm.model_name }}</td>
                        <td>{{ dm.common_name }}</td>
                        <td>{{ dm.device_type }}</td>
                        <td class="small">{{ dm.cpu }}</td>
                        <td class="small">{{ dm.ram }}</td>
                        <td class="small">{{ dm.storage }}</td>
                        <td class="text-end">{{ dm.order_count }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import { APIService } from "../http/APIService";

export default {
  name: "DeviceModelsList",
  data() {
    return {
      models: [],
      loading: false,
      error: null,
      search: "",
      api: new APIService(),
    };
  },
  computed: {
    isSupervisor() {
      try {
        const raw = localStorage.getItem("currentUser");
        if (!raw) return false;
        const user = JSON.parse(raw);
        const role = (user.role || "").toLowerCase();
        return role === "supervisor" || role === "admin";
      } catch {
        return false;
      }
    },
    filteredModels() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.models;
      return this.models.filter((dm) => {
        return (
          (dm.make || "").toLowerCase().includes(q) ||
          (dm.model_name || "").toLowerCase().includes(q) ||
          (dm.common_name || "").toLowerCase().includes(q)
        );
      });
    },
  },
  created() {
    this.fetchModels();
  },
  methods: {
    async fetchModels() {
      this.loading = true;
      this.error = null;
      try {
        const accessToken = localStorage.getItem("accessToken");
        const res = await this.api.getDeviceModels(accessToken);
        this.models = res.data || [];
      } catch {
        this.error = "Unable to load device models.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer:hover {
  background-color: #f0f0f0;
}
</style>
